import { render } from "./Attrs.vue?vue&type=template&id=042e1028&scoped=true"
import script from "./Attrs.vue?vue&type=script&lang=ts"
export * from "./Attrs.vue?vue&type=script&lang=ts"

import "./Attrs.vue?vue&type=style&index=0&id=042e1028&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-042e1028"

export default script